import api from '../../../api/clinique/_examens'

export default {
    getExamens() {
        return new Promise((resolve) => {
            api.getExamens().then((response) => {
                resolve(response);
            });
        });
    },

    getAllExamensForExterne() {
        return new Promise((resolve, reject) => {
            api.getAllExamensForExterne().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getBulletinExamen(data) {
        return new Promise((resolve, reject) => {
            api.getBulletinExamen(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}